<template>
  <BaseNotification
    type="warning"
    :title="minHoursForBooking + (minHoursForBooking > 1 ? ' hours minimum' : ' hour minimum')"
  >
    This venue accepts bookings for minimum of {{ minHoursForBooking }} {{ minHoursForBooking > 1 ? 'hours' : 'hour' }}.
  </BaseNotification>
</template>

<script>
import BaseNotification from '@/components/Ui/BaseNotification.vue';

export default {
  name: 'MinimumBookingTimeWarning',
  components: { BaseNotification },
  props: {
    minHoursForBooking: {
      type: Number,
      required: true,
    },
  },
};
</script>
